import styled from "styled-components";
import { ConfirmationModal } from "./ConfirmationModal";


export const StyledConfirmationModal = styled(ConfirmationModal)`
`;